import { render, staticRenderFns } from "./ListingDetails.vue?vue&type=template&id=2bd4770e&scoped=true"
import script from "./ListingDetails.vue?vue&type=script&lang=js"
export * from "./ListingDetails.vue?vue&type=script&lang=js"
import style0 from "./ListingDetails.vue?vue&type=style&index=0&id=2bd4770e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd4770e",
  null
  
)

export default component.exports